import { useState } from "react";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandLockup, ShelfArt } from "@/components/bakery/Art";
import { Field, inputCls } from "@/components/common/Field";
import { PrimaryBtn } from "@/components/common/ui";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="grid min-h-screen bg-paper lg:grid-cols-[1.1fr_1fr]" data-testid="login-page">
      <div className="grain relative flex flex-col overflow-hidden bg-ink text-white">
        <div className="awning" />
        <div className="flex flex-1 flex-col justify-between gap-10 px-6 pb-10 pt-12 sm:px-12 lg:px-16">
          <BrandLockup className="h-20 w-auto self-start" />
          <div>
            <div className="eyebrow mb-3">100% Whole Wheat · Jakarta</div>
            <h1 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">Dari dapur<br />sampai kartu stok.</h1>
            <p className="mt-4 max-w-md text-sm text-zinc-400 md:text-base">Satu ledger untuk produksi, waste, penjualan, purchase, dan penyesuaian. Stok roti jadi selalu jelas — tanpa angka uang.</p>
          </div>
          <ShelfArt className="hidden h-44 w-64 text-white/90 lg:block" />
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <h2 className="font-display text-3xl font-extrabold tracking-tight">Masuk</h2>
            <p className="mt-1 text-sm text-zinc-500">Akun dibuat oleh Admin. Hubungi Admin jika lupa password.</p>
          </div>
          <Field label="Email"><input type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email" /></Field>
          <Field label="Password">
            <div className="relative">
              <input type={show ? "text" : "password"} required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} pr-11`} data-testid="login-password" />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500" data-testid="login-toggle-password">{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</button>
            </div>
          </Field>
          {error && <div className="rounded-md bg-brand px-3 py-2.5 text-sm font-medium text-white" data-testid="login-error">{error}</div>}
          <PrimaryBtn type="submit" className="w-full" disabled={busy} data-testid="login-submit"><LogIn className="h-4 w-4" /> {busy ? "Memeriksa…" : "Masuk"}</PrimaryBtn>
        </form>
      </div>
    </div>
  );
}
